/*
 * @Author: liyxt
 * @Date: 2020-05-29 09:53:24
 * @LastEditors: liyxt
 * @LastEditTime: 2020-06-02 14:34:27
 * @Description: file content
 */

export function getLangCode() {
    return localStorage.getItem('langCode') || 'simpchn';
}

export let localeLang = getLangCode();

export function getWeekStartDay() {
    let localeLang = getLangCode();
    if (localeLang === 'simpchn' || localeLang === 'tradchn' || !localeLang) { //简体和繁体是一开头，其他的是日开头
        return 1;
    } else{ 
        return 0;
    }
}
